import axios from '../../axios'
import store from "../store";
export default {
  async setUser({ commit },user) {
    let {data} = await axios.post('/auth/edit',user)
    store.dispatch('lists/getListUser');
    commit('trash_user')
  },
  async regUser({ commit },user) {
    let {data} = await axios.post('/auth/signup',user)
    store.dispatch('lists/getListUser');
    commit('trash_user')
  }
}
